import { render, staticRenderFns } from "./coach-result-candidates-modal.vue?vue&type=template&id=2d36bf63"
import script from "./coach-result-candidates-modal.vue?vue&type=script&lang=js"
export * from "./coach-result-candidates-modal.vue?vue&type=script&lang=js"
import style0 from "./coach-result-candidates-modal.vue?vue&type=style&index=0&id=2d36bf63&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports